<template>
  <div class="snackbar-container">
    <div v-for="(snackbar, index) in snackbars" :key="index">
      <v-snackbar
        v-model="snackbar.isVisible"
        style="filter: none"
        :bottom="snackbar.position.includes('bottom')"
        :color="snackbar.color"
        :left="snackbar.position.includes('left')"
        :right="snackbar.position.includes('right')"
        :timeout="snackbar.timeout"
        :top="snackbar.position.includes('top')"
        :vertical="true"
        multi-line
      >
        <div v-html="snackbar.text"></div>
        <v-btn dark text @click="snackbar.isVisible = false"> OK </v-btn>
      </v-snackbar>
    </div>
  </div>
</template>

<script lang="ts">
import "reflect-metadata";
import { Component, Vue } from "vue-property-decorator";
import { SnackbarModel } from "@/models/components/popup/Snackbar";
import IsVisible from "@/models/components/popup/IsVisible";

@Component
export default class Snackbar extends Vue {
  get snackbars(): Array<SnackbarModel & IsVisible> {
    return this.$store.direct.state.popup.snackbars;
  }
}
</script>

<style lang="scss" scoped>
.snackbar-container {
  z-index: 99999;
}
</style>
